import { ContractTemplate, CommonListResponse } from 'common/types';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';

const contract = {
  //前台获取合同模板列表
  getContractTemplateList: () => {
    return FastApiAxiosInstance.get<CommonListResponse<ContractTemplate>>('/api/v1/user/contract/template/list');
  },
  //前台预览合同模板
  previewContractTemplate: (params: { templateId: number }) => {
    return FastApiAxiosInstance.post<Blob>('/api/v1/user/contract/template/preview', params, {
      responseType: 'arraybuffer',
    });
  },
  //前台签署合同
  signContract: (params: {
    templateId?: number;
    parentTaskId: number;
    extraInfo: {
      address: string;
      bankBranch: string;
      email: string;
    };
  }) => {
    return FastApiAxiosInstance.post('/api/v1/user/contract/sign', params);
  },
  //查询合同是否签署
  checkContractSign: (params: { templateId: number }) => {
    return FastApiAxiosInstance.post<boolean>('/api/v1/user/contract/status/valid', params);
  },
  download: (params: { contractId: number }) => {
    //请求接口，返回合同文件流
    return FastApiAxiosInstance.post<any>('/api/v1/user/contract/download', params, { responseType: 'blob' });
  },
};

export default contract;
